<template>
    <div class="lg:grid lg:gap-4 lg:grid-cols-12">
        <Head :title="title" />

        <div class="content-top col-span-12 min-h-screen xl:col-span-8">
            <div class="flex flex-col gap-2">
                <div class="block sm:hidden px-2">
                    <Link-button :href="route('posts.create')" class="w-full" color="indigo">
                        <svg class="-ml-1 mr-1 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path d="M12 6v6m0 0v6m0-6h6m-6 0H6" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                        </svg>
                        New Challenge
                    </Link-button>
                </div>
                <feed :data="posts"></feed>
            </div>
        </div>

        <div class="hidden xl:block xl:col-span-4 pr-6">
            <div :class="[installable ? 'top-24' : 'top-8']" class="sticky space-y-4">
                <div class="bg-white dark:bg-slate-800 rounded-lg shadow overflow-hidden">
                    <div class="px-5 py-3">
                        <div class="flex items-center">
                            <div class="flex-1">
                                <dl>
                                    <dt class="pb-1 text-gray-500 dark:text-gray-100 font-medium truncate">Token Balance</dt>
                                    <dd>
                                        <Link :href="route('wallet.show')" class="text-gray-900 hover:text-indigo-900 dark:text-gray-200 text-2xl font-medium">
                                            {{ $page.props.user.wallet.balance | toLocaleString }}
                                        </Link>
                                    </dd>
                                </dl>
                            </div>
                            <div class="flex items-center">
                                <jet-button @click.native="$root.$emit('showBuyTokensModal')">Buy Tokens</jet-button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Activity Feed-->
                <activity-feed :data.sync="activityData" />

                <!-- Accepted Challenges -->
                <recent-accepted-challenges />
            </div>
        </div>
    </div>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout"
import Feed from "@/Pages/Dashboard/Feed"
import JetDialogModal from "@/Jetstream/DialogModal"
import JetSecondaryButton from "@/Jetstream/SecondaryButton"
import Heading from "@/Components/Heading"
import JetButton from "@/Jetstream/Button"
import SectionTitle from "@/Jetstream/SectionTitle"
import ActivityFeed from "@/Pages/Dashboard/ActivityFeed"
import RecentAcceptedChallenges from "@/Pages/Dashboard/RecentAcceptedChallenges"
import LinkButton from "@/Components/Buttons/LinkButton.vue"

export default {
    name: "Dashboard",

    layout: AppLayout,

    components: {
        LinkButton,
        RecentAcceptedChallenges,
        ActivityFeed,
        SectionTitle,
        JetButton,
        Heading,
        Feed,
        JetDialogModal,
        JetSecondaryButton,
    },

    props: {
        posts: Object,
        activityFeed: Array,
    },

    computed: {
        title() {
            return this.$page.url === "/dashboard" ? "Home" : "Recent Challenges"
        },
        installable() {
            return this.$parent.installable
        },
    },

    data() {
        return {
            reportingPost: false,
            activityData: this.activityFeed,
        }
    },
}
</script>
